import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "terminal-file-view" }
const _hoisted_2 = { class: "view-header" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = { class: "header-icon" }
const _hoisted_6 = { class: "header-subtitle" }
const _hoisted_7 = { class: "ship-id-tag" }
const _hoisted_8 = { class: "stat-row" }
const _hoisted_9 = { class: "stat-card stat-blue" }
const _hoisted_10 = { class: "stat-icon" }
const _hoisted_11 = { class: "stat-info" }
const _hoisted_12 = { class: "stat-value" }
const _hoisted_13 = { class: "stat-card stat-green" }
const _hoisted_14 = { class: "stat-icon" }
const _hoisted_15 = { class: "stat-info" }
const _hoisted_16 = { class: "stat-value" }
const _hoisted_17 = { class: "stat-icon" }
const _hoisted_18 = { class: "stat-info" }
const _hoisted_19 = { class: "stat-value" }
const _hoisted_20 = { class: "stat-card stat-purple" }
const _hoisted_21 = { class: "stat-icon" }
const _hoisted_22 = { class: "stat-info" }
const _hoisted_23 = { class: "stat-value stat-time" }
const _hoisted_24 = { class: "main-content" }
const _hoisted_25 = { class: "missing-list" }
const _hoisted_26 = { class: "missing-name" }
const _hoisted_27 = { class: "missing-en" }
const _hoisted_28 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_29 = {
  key: 2,
  class: "file-grid"
}
const _hoisted_30 = { class: "file-card-icon" }
const _hoisted_31 = { class: "file-card-content" }
const _hoisted_32 = { class: "file-name-cn" }
const _hoisted_33 = ["title"]
const _hoisted_34 = { class: "file-card-actions" }
const _hoisted_35 = { class: "trans-header" }
const _hoisted_36 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_37 = { class: "cell-cn" }
const _hoisted_38 = { class: "cell-en" }
const _hoisted_39 = { class: "dialog-file-name" }

import { ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import {
  ArrowLeft,
  ChatLineRound,
  Clock,
  Connection,
  Document,
  Files,
  FolderOpened,
  Link,
  Refresh,
  Search,
  WarningFilled,
} from "@element-plus/icons-vue";
import {
  syncProtocolFilesApi,
  listTranslationsApi,
  listProtocolFilesApi,
  addTranslationApi,
  type ProtocolFile,
  type MissingDevice,
} from "@/api/svc005Api";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProtocolFileView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const shipId = ref((route.query.shipId as string) || "");
const activeTab = ref("files");
const syncing = ref(false);
/** 终端协议文件列表（同步结果中的 files） */
const files = ref<ProtocolFile[]>([]);
/** 库有板无的设备清单（只读对账结果：提示可删除，不自动删） */
const missingDevices = ref<MissingDevice[]>([]);
const translations = ref<ProtocolFile[]>([]);
const translationSearch = ref("");
const lastSyncTime = ref("");
const addDialogVisible = ref(false);
const adding = ref(false);
const addForm = ref({ fileName: "", devName: "", enName: "" });

/** 搜索过滤后的翻译记录 */
const filteredTranslations = computed(() => {
  const kw = translationSearch.value.trim().toLowerCase();
  if (!kw) return translations.value;
  return translations.value.filter(
    (t) =>
      (t.devName || "").toLowerCase().includes(kw) ||
      (t.enName || "").toLowerCase().includes(kw)
  );
});

/** 格式化时间戳为 yyyy-MM-dd HH:mm:ss */
const formatTime = (date: Date) => {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
    date.getSeconds()
  )}`;
};

/**
 * 展示板子文件名：统一带 .json 后缀（一眼可辨是终端上的协议文件，区别于上方中文设备名）。
 * 同步接口返回 fileName 自带后缀；缓存查询回退 enName 需补全；中文旧文件名保持原样。
 */
const displayFileName = (file: ProtocolFile): string => {
  const name = file.fileName || file.enName || "";
  if (!name) return "";
  return name.includes(".") ? name : `${name}.json`;
};

/** [5,7] 同步终端协议文件列表 + 库有板无对账 */
const handleSync = async () => {
  if (!shipId.value) {
    ElMessage.warning("缺少船舶ID");
    return;
  }
  syncing.value = true;
  try {
    const result = await syncProtocolFilesApi(shipId.value);
    if (result) {
      files.value = result.files || [];
      missingDevices.value = result.missingDevices || [];
      lastSyncTime.value = formatTime(new Date());
      const missing = missingDevices.value.length;
      ElMessage.success(
        missing > 0
          ? `同步成功，共 ${files.value.length} 个文件；对账发现 ${missing} 个设备终端缺文件，请查看告警`
          : `同步成功，共 ${files.value.length} 个文件，对账无差异`
      );
    }
  } finally {
    syncing.value = false;
  }
};

/** 查询终端协议文件缓存（附带对账结果） */
const loadProtocolFiles = async () => {
  if (!shipId.value) return;
  const result = await listProtocolFilesApi(shipId.value);
  if (result) {
    files.value = result.files || [];
    missingDevices.value = result.missingDevices || [];
    // 取最新一条的 syncTime 显示（列表按 syncTime 降序）
    lastSyncTime.value = files.value[0]?.syncTime || "";
  }
};

/** 打开"加入翻译表"对话框，预填文件名信息 */
const openAddDialog = (file: ProtocolFile) => {
  addForm.value = {
    fileName: file.fileName || file.enName,
    devName: file.devName || "",
    enName: file.enName,
  };
  addDialogVisible.value = true;
};

/** 确认加入翻译表 */
const handleAddTranslation = async () => {
  if (!addForm.value.devName || !addForm.value.enName) {
    ElMessage.warning("中文名和英文名都不能为空");
    return;
  }
  adding.value = true;
  try {
    const ok = await addTranslationApi(
      shipId.value,
      addForm.value.enName,
      addForm.value.devName
    );
    if (ok) {
      ElMessage.success("已加入翻译表");
      addDialogVisible.value = false;
      await loadProtocolFiles();
    }
  } finally {
    adding.value = false;
  }
};

/** 查询所有翻译对应关系 */
const loadTranslations = async () => {
  const result = await listTranslationsApi();
  if (result) translations.value = result;
};

onMounted(() => {
  loadTranslations();
  if (shipId.value) loadProtocolFiles();
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "header-bg" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "back-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowLeft))
              ]),
              _: 1
            }),
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "返回", -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Files))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _cache[11] || (_cache[11] = _createElementVNode("h1", { class: "header-title" }, "终端文件管理", -1)),
            _createElementVNode("p", _hoisted_6, [
              _cache[8] || (_cache[8] = _createTextVNode(" 船舶ID：", -1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString(shipId.value), 1),
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "dot" }, "·", -1)),
              _cache[10] || (_cache[10] = _createTextVNode(" 协议文件查看与同步 ", -1))
            ])
          ])
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: syncing.value,
          class: "sync-btn",
          onClick: handleSync
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Refresh))
              ]),
              _: 1
            }),
            _createElementVNode("span", null, _toDisplayString(syncing.value ? "同步中..." : "同步终端文件"), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Document))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "stat-label" }, "终端文件数", -1)),
          _createElementVNode("div", _hoisted_12, _toDisplayString(files.value.length), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Connection))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "stat-label" }, "翻译记录数", -1)),
          _createElementVNode("div", _hoisted_16, _toDisplayString(translations.value.length), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["stat-card stat-red", { 'stat-alert': missingDevices.value.length > 0 }])
      }, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(WarningFilled))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "stat-label" }, "缺失文件设备", -1)),
          _createElementVNode("div", _hoisted_19, _toDisplayString(missingDevices.value.length), 1)
        ])
      ], 2),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Clock))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_22, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "stat-label" }, "最近同步", -1)),
          _createElementVNode("div", _hoisted_23, _toDisplayString(lastSyncTime.value || "未同步"), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createVNode(_component_el_tabs, {
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeTab).value = $event)),
        class: "main-tabs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, { name: "files" }, {
            label: _withCtx(() => [
              _cache[17] || (_cache[17] = _createTextVNode(" 终端协议文件 ", -1)),
              (missingDevices.value.length > 0)
                ? (_openBlock(), _createBlock(_component_el_badge, {
                    key: 0,
                    value: missingDevices.value.length,
                    type: "danger",
                    class: "tab-badge"
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              (missingDevices.value.length > 0)
                ? (_openBlock(), _createBlock(_component_el_alert, {
                    key: 0,
                    type: "warning",
                    "show-icon": "",
                    closable: false,
                    class: "reconcile-alert"
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode(" 对账发现 " + _toDisplayString(missingDevices.value.length) + " 个后端设备在终端无对应协议文件（设备实际不可用）， 可到", 1),
                      _cache[18] || (_cache[18] = _createElementVNode("b", null, "用户端-设备管理", -1)),
                      _cache[19] || (_cache[19] = _createTextVNode("中删除 ", -1))
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(missingDevices.value, (d) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: d.deviceId,
                            class: "missing-item"
                          }, [
                            _createElementVNode("span", _hoisted_26, _toDisplayString(d.devName), 1),
                            _createElementVNode("span", _hoisted_27, _toDisplayString(d.protName || d.enName || "（未推送协议）"), 1),
                            (d.terminalMissing)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 0,
                                  size: "small",
                                  type: "info",
                                  effect: "plain"
                                }, {
                                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                    _createTextVNode(" 已置灰 ", -1)
                                  ]))]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (files.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createVNode(_component_el_empty, { description: "暂无终端文件，请点击右上角同步" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: handleSync
                        }, {
                          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                            _createTextVNode("立即同步", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: idx,
                        class: "file-card"
                      }, [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Document))
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, _toDisplayString(file.devName || "未知设备"), 1),
                          _createElementVNode("div", {
                            class: "file-name-en",
                            title: displayFileName(file)
                          }, [
                            _createVNode(_component_el_icon, { class: "file-name-icon" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(FolderOpened))
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" " + _toDisplayString(displayFileName(file)), 1)
                          ], 8, _hoisted_33),
                          _createElementVNode("div", _hoisted_34, [
                            (file.matched)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 0,
                                  size: "small",
                                  type: "success",
                                  effect: "light",
                                  class: "file-tag"
                                }, {
                                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                    _createTextVNode(" 已匹配 ", -1)
                                  ]))]),
                                  _: 1
                                }))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createVNode(_component_el_tag, {
                                    size: "small",
                                    type: "warning",
                                    effect: "light",
                                    class: "file-tag"
                                  }, {
                                    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                      _createTextVNode(" 未匹配 ", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_button, {
                                    size: "small",
                                    type: "primary",
                                    text: "",
                                    onClick: ($event: any) => (openAddDialog(file))
                                  }, {
                                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                      _createTextVNode(" 加入翻译表 ", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ], 64))
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "翻译对应关系",
            name: "translations"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_el_input, {
                  modelValue: translationSearch.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((translationSearch).value = $event)),
                  placeholder: "搜索中文名或英文名",
                  clearable: "",
                  class: "search-input"
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Search))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  class: "refresh-btn",
                  onClick: loadTranslations
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Refresh))
                      ]),
                      _: 1
                    }),
                    _cache[25] || (_cache[25] = _createElementVNode("span", null, "刷新", -1))
                  ]),
                  _: 1
                })
              ]),
              (filteredTranslations.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createVNode(_component_el_empty, {
                      description: 
                translationSearch.value ? '没有匹配的翻译记录' : '暂无翻译记录'
              
                    }, null, 8, ["description"])
                  ]))
                : (_openBlock(), _createBlock(_component_el_table, {
                    key: 1,
                    data: filteredTranslations.value,
                    border: "",
                    stripe: "",
                    class: "translation-table"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        type: "index",
                        label: "#",
                        width: "60",
                        align: "center"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "中文名",
                        "min-width": "200"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ChatLineRound))
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", null, _toDisplayString(row.devName), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "英文名",
                        "min-width": "240"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createElementVNode("div", _hoisted_38, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Link))
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", null, _toDisplayString(row.enName), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: addDialogVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addDialogVisible).value = $event)),
      title: "加入翻译表",
      width: "460px",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (addDialogVisible.value = false))
        }, {
          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: adding.value,
          onClick: handleAddTranslation
        }, {
          default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
            _createTextVNode(" 确认加入 ", -1)
          ]))]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "90px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "终端文件名" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_39, _toDisplayString(addForm.value.fileName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "中文名" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: addForm.value.devName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((addForm.value.devName) = $event)),
                  placeholder: "设备中文名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "英文名" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: addForm.value.enName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addForm.value.enName) = $event)),
                  placeholder: "英文名称（去后缀）"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})